module.exports = __webpack_public_path__ + "img/uk-digestive-diseases-female.b1ac64ba.png";